<template lang="pug">
  div(v-if='available')
    .c-heading-belt--lv1.u-mbxs
      | There’s more!
    div(v-html='contents')
</template>

<script>
export default {
  data() {
    return {
      contents: ''
    };
  },
  props: ['productId', 'pageNameForImpression'],
  computed: {
    available() {
      return this.contents !== '';
    }
  },
  methods: {
    initSuggestedProducts() {
      $.ajax({
        url: tom.conf.sslUrl + 'shop/suggested_products',
        method: 'GET',
        data: {
          id: this.productId,
          columns: 2,
          impression_list: `${this.pageNameForImpression} - Related Product`,
          limit: 10,
          must_return: '1'
        },
        dataType: 'HTML',
        xhrFields: {
          withCredentials: true
        },
        success: (data) => {
          this.contents = data;
          if (this.contents) {
            this.$nextTick(() => {
              window.lozadObserver.observe();
            });
          }
        }
      });
    }
  },
  mounted() {
    if (window.suggestedProductsProvider.provider) {
      window.suggestedProductsProvider.setResolver((data) => {
        this.contents = data;
      });
    } else {
      this.initSuggestedProducts();
    }
  }
};
</script>
